(function () {
  if (window.DTDBCartQty8) return;
  window.DTDBCartQty8 = true;

  var money = function (cents) {
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  var trim = function (n) { return Number(n.toFixed(2)).toString(); };
  var pending = new Set();

  var paint = function (qs, n) {
    var input = qs.querySelector('input');
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    input.style.setProperty('--quantity-input-characters-count', String(n).length + 'ch');
    var dec = qs.querySelector('[data-dtdb-step="-1"]'), inc = qs.querySelector('[data-dtdb-step="1"]');
    if (dec) dec.disabled = n <= min;
    if (inc) inc.disabled = n >= max;
    if (qs.dataset.cov) {
      var noun = qs.querySelector('[data-dtdb-noun]'), area = qs.querySelector('[data-dtdb-area]');
      if (noun) noun.textContent = n === 1 ? qs.dataset.noun : qs.dataset.plural;
      if (area) area.textContent = '= ' + trim(parseFloat(qs.dataset.cov) * n) + ' m\u00b2';
    }
    var line = qs.closest('line-item, tr');
    if (line && qs.dataset.unitPrice) {
      line.querySelectorAll('[data-dtdb-line-total]').forEach(function (t) { t.textContent = money(parseInt(qs.dataset.unitPrice, 10) * n); });
    }
  };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dtdb-step]');
    if (!b) return;
    var qs = b.closest('[data-dtdb-qs]');
    var input = qs && qs.querySelector('input');
    if (!input) return;
    e.preventDefault();
    var min = parseInt(input.min, 10) || 1;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var step = parseInt(input.step, 10) || 1;
    var cur = parseInt(input.value, 10) || min;
    var next = Math.min(max, Math.max(min, cur + step * parseInt(b.getAttribute('data-dtdb-step'), 10)));
    if (next === cur) return;
    input.value = next;
    paint(qs, next);
    clearTimeout(qs.__dtdbTimer);
    pending.add(qs);
    qs.__dtdbTimer = setTimeout(function () {
      pending.delete(qs);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 450);
  });

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var checkoutTimer;
  var note = function (s, html) {
    var anchor = s.closest('.buy-buttons') || s;
    var n = anchor.nextElementSibling;
    if (!n || !n.classList.contains('dtdb-checkout-note')) {
      n = document.createElement('p');
      n.className = 'text-sm dtdb-checkout-note';
      n.setAttribute('role', 'status');
      anchor.insertAdjacentElement('afterend', n);
    }
    n.innerHTML = html;
  };
  var watch = function (s) {
    clearTimeout(checkoutTimer);
    checkoutTimer = setTimeout(function () {
      s.removeAttribute('aria-busy');
      note(s, 'Checkout is taking longer than usual. <a class="link" href="' + root + 'checkout">Open checkout</a>');
    }, 12000);
  };
  window.addEventListener('pagehide', function () { clearTimeout(checkoutTimer); });

  document.addEventListener('submit', function (e) {
    var s = e.submitter, form = e.target;
    if (!s || s.name !== 'checkout') return;
    if (document.querySelector('[data-dtdb-instore]')) return;
    if (window.Shopify && Shopify.designMode) {
      e.preventDefault();
      e.stopImmediatePropagation();
      note(s, 'Checkout can\u2019t open inside the theme editor. To test it, open the theme with Preview.');
      return;
    }
    if (!pending.size) {
      setTimeout(function () { if (!e.defaultPrevented) watch(s); }, 0);
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    var updates = {};
    pending.forEach(function (qs) {
      clearTimeout(qs.__dtdbTimer);
      var input = qs.querySelector('input');
      var key = input && input.getAttribute('data-line-key');
      if (key) updates[key] = parseInt(input.value, 10) || 1;
    });
    pending.clear();
    s.setAttribute('aria-busy', 'true');
    var go = function () {
      if (form.isConnected && form.requestSubmit) form.requestSubmit(s);
      else { watch(s); window.location.href = root + 'checkout'; }
    };
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(go, go);
  }, true);

  document.addEventListener('input', function (e) {
    var qs = e.target.closest && e.target.closest('[data-dtdb-qs]');
    if (qs) paint(qs, parseInt(e.target.value, 10) || 0);
  });
})();
(function () {
  if (window.__dtdbInStoreGuard) return;
  window.__dtdbInStoreGuard = true;
  var blocked = function () { return !!document.querySelector('[data-dtdb-instore]'); };
  document.addEventListener('submit', function (e) {
    if (!blocked()) return;
    var f = e.target;
    var s = e.submitter;
    if ((s && s.name === 'checkout') || (f && f.querySelector && f.querySelector('[name="checkout"]'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (!blocked()) return;
    var a = e.target.closest && e.target.closest('a[href*="/checkout"], [name="checkout"]');
    if (a) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
})();
